import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Toast } from 'antd-mobile';
import queryString from 'query-string';
import Empty from '../../components/common/Empty';
import Http from '../../config/axiosUtils';
import GroupItem from '../../components/team/GroupItem';
import { getStore } from '../../config/storage';

class GroupDetail extends Component {
  state = {
    groupList: [],
    from: '',
    teamLevel: null
  }

  componentDidMount() {
    const { from } = queryString.parse(this.props.location.search);
    this.setState({
      from: from,
      teamLevel: getStore('teamLevel')
    }, () => {
      this.fetchData();
    })
  }

  fetchData = async () => {
    const path = this.state.from === 'isInvite' ? '/spread/web/user/account/invite/accounts' : '/spread/web/team/referrer/accounts';
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        groupList: res.data
      })
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  btnClickFunc = () => {
    this.props.history.push('/inviteHome/team');
  }

  groupClickFuc = (id) => {
    this.props.history.push(`/teamHome/${id}?teamLevel=${this.state.teamLevel}`);
  }

  render () {
    const { groupList } = this.state;
    return (
      <div>
        <Helmet><title>团队成员</title></Helmet>
        {groupList && groupList.length > 0 ? <GroupItem groupList={groupList} teamLevel={this.state.teamLevel} groupClickFuc={this.groupClickFuc}></GroupItem> : <div style={{paddingTop: '0.66rem'}}>{this.state.from === 'isInvite' ? <Empty tip='暂无数据...' /> : <Empty tip='您还没有队员，快去邀请吧' btnTitle='邀请队员' btnClickFunc={this.btnClickFunc} />}</div>}
      </div>
    )
  }
}

export default GroupDetail;